// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"665e2fec96182e71","4045":"7e2fa6399f933c9c","6642":"7e2fa6399f933c9c","9900":"7e2fa6399f933c9c"}[chunkId] + ".css";
};